<div class="custom-loader" *ngIf="isLoading">
    <div class="loader-overlay"></div>

    <div class="loader-content">
        <div class="spinner"></div>
        <p>Processing payment...</p>
    </div>
</div>

<div class="web">
    <div class="container-bg">
        <div class="golf-course-background">
            <div class="image-wrapper">
                <img src="/assets/Cover photo.jpg" alt=""
                    class="bg-image">
            </div>
        </div>
        <div class="gradient"></div>
    </div>

    <div class="background-border-overlay-blur">
        <div class="image-1">
            <img src="/assets/Cover photo.jpg" alt=""
                class="logo-img">
        </div>

        <div class="heading-1-margin">
            <div class="heading-1-wrapper">
                <div class="heading-1">
                    <div class="heading-1-text">
                        <p>Karnataka Golf Association</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="margin-1">
            <div class="margin-1-wrapper">
                <div class="container-amount">
                    <div class="margin-3">
                        <div class="background-border-shadow px-2">
                            <div class="amount-text">
                                <p>
                                    ₹ {{ transactionAmount | number:'1.2-2' }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-button">
            <div class="button-wrapper">
                <div class="background-button" [class.disabled]="transactionAmount == 0 || !paymentLink"
                    (click)="transactionAmount != 0 && paymentLink && redirectLink()">
                    <div class="button-content">
                        <div class="button-inner">
                            <div class="overlay-shadow"></div>
                            <div class="button-text">
                                <p>Pay Now</p>
                            </div>
                            <div class="svg-arrow">
                                <svg fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
                                    <g>
                                        <path d="M4.16667 10H15.8333M10 4.16667L15.8333 10L10 15.8333" stroke="white"
                                            stroke-linecap="round" stroke-linejoin="round" stroke-width="1.66667" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-secure">
                    <div class="svg-lock">
                        <div class="group-lock">
                            <div class="group-lock-inner">
                                <svg fill="none" preserveAspectRatio="none" viewBox="0 0 11.6667 12.8333">
                                    <g>
                                        <path
                                            d="M1.75 5.83333H9.91667C10.5606 5.83333 11.0833 6.3561 11.0833 7V11.0833C11.0833 11.7272 10.5606 12.25 9.91667 12.25H1.75C1.1061 12.25 0.583333 11.7272 0.583333 11.0833V7C0.583333 6.3561 1.1061 5.83333 1.75 5.83333V5.83333"
                                            stroke="#6B7B74" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="1.16667" />
                                        <path
                                            d="M2.91667 5.83333V3.5C2.91667 1.89025 4.22358 0.583333 5.83333 0.583333C7.44308 0.583333 8.75 1.89025 8.75 3.5V5.83333"
                                            stroke="#6B7B74" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="1.16667" />
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="secure-text">
                        <p>Secure payment</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>